import dialogClasses from "@mui/material/Dialog/dialogClasses";
export const MuiDialogTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                [`.${dialogClasses.paper}`]: {
                    borderRadius: dt.brand.borderRadius.medium,
                    boxShadow: dt.elevation.level3,
                },
                [`.${dialogClasses.paperFullScreen}`]: {
                    margin: 0,
                    height: "100vh",
                    maxWidth: "unset !important",
                    borderRadius: 0,
                },
            },
        },
    };
};
